export default function FullscreenIcon() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="39.684" height="39.684" viewBox="0 0 39.684 39.684">
  <g id="imggal_full_button" transform="translate(-669.262 -10582.643)">
    <path id="Pfad_35" data-name="Pfad 35" d="M1140.29,104.85V81.06H1116.5" transform="translate(-433.344 10503.582)" fill="none" stroke="#fff" stroke-width="4"/>
    <path id="Pfad_36" data-name="Pfad 36" d="M1116.5,81.06V104.85h23.789" transform="translate(-445.238 10515.477)" fill="none" stroke="#fff" stroke-width="4"/>
  </g>
</svg>
}